import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después de tu pago recibes un email con el enlace de descarga. El acceso es instantáneo, las 24 hs, los 7 días de la semana.'
  }, {
    q: '¿Sirve si soy profe nuevo o si tengo experiencia?',
    a: 'Sirve para los dos perfiles. Si eres nuevo, el sistema te da estructura desde el día 1. Si ya tienes experiencia, te ahorra horas de planificación y te da herramientas que no encuentras en ningún otro material del mercado.'
  }, {
    q: '¿Los 6 Bonus están en las dos opciones?',
    a: 'Sí. Los 6 Bonus están incluidos en el Pack Profesional y en el Megapack Élite. La diferencia del Megapack son los 2 Ebooks Élite (Manual de Modificaciones y Energía Blindada).'
  }, {
    q: '¿Qué diferencia hay con otros materiales que ya existen?',
    a: 'YOGA 360 es el único sistema diseñado específicamente para el contexto del profesor de yoga. Todos los contenidos están adaptados al idioma, los niveles y las necesidades reales de las clases.'
  }, {
    q: '¿Sirve para distintos niveles mezclados en el mismo grupo?',
    a: 'Sí. Cada tomo tiene variantes para distintos niveles dentro del mismo grupo. El sistema de modificaciones del Élite 1 también te ayuda a manejar diferentes capacidades.'
  }, {
    q: '¿Qué pasa si no me sirve?',
    a: 'Tienes 7 días de garantía total. Si no es lo que esperabas, te devolvemos el 100% del dinero. Sin preguntas y sin formularios.'
  }, {
    q: '¿Vale la pena el Megapack Élite si ya planifico bien mis clases?',
    a: 'Si ya planificas bien, el Élite te da dos cosas que ningún sistema de planificación incluye: seguridad técnica ante lesiones y herramientas de autocuidado. La mayoría de los profes que lo compraron dicen que el Élite 2 (Energía Blindada) fue lo que más impacto tuvo en su carrera.'
  }, {
    q: '¿Puedo pagar con tarjeta de crédito?',
    a: 'Sí. Aceptamos todas las tarjetas de crédito y débito, y también transferencia bancaria.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 px-4 bg-hueso" data-id="element-67" data-mp="1xpwzsuop3kqo">
      <div className="max-w-3xl mx-auto" data-id="element-68" data-mp="1xrromk337x01">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center text-oscuro mb-12" data-id="element-69" data-mp="22pjg5cztlh3p">
          Preguntas Frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-70" data-mp="2giiuvcrs37a7">
          {faqs.map((faq, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-71" data-mp="2lhcapbujfadj" data-mpi={idx}>
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none" data-id="element-72" data-mp="3w170eutj9f2k">
                <span className="font-bold text-oscuro pr-4" data-id="element-73" data-mp="sl9n4d02rr00">{faq.q}</span>
                <motion.div animate={{
              rotate: openIndex === idx ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0 text-terracota" data-id="element-74" data-mp="nqm9582p6ezo">
                  <ChevronDown size={20} data-id="element-75" data-mp="1bg841jc1e81v" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-76" data-mp="vy6w5x19qq9o">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} data-id="element-77" data-mp="10zw7zewbf7yt">
                    <div className="px-6 pb-5 text-gray-600 leading-relaxed" data-id="element-78" data-mp="14zojo0h09u8e">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}